module.exports = __webpack_public_path__ + "img/founders_03.885b8592.jpg";